
// Used through the app to provide routes
// to navigate to

// APP ROUTES
export const internalRoutes = {
    // ---- Meta navigation
    authentication: "/authentification",
    // ---- Main navigation
    home: "/",
    games: "/jeux",
    glossary: "/glossaire",
    courses: "/cours-et-exercices",
    knowledges: "/connaissances",
    // ---- Games
    multiplicationGame: "/jeux/tables-multiplication",
    relativeSumGame: "/jeux/addition-relatifs",
    // ---- Side navigation
    about: "/a-propos",
    legals: "/mentions-legales",
    privacy: "/confidentialite",
    support: "/soutenir",
    themes: "/programme",
    // ---- Off limit navigation
    previewQuestion: "/preview/question/:id",
    previewExerciser: "/preview/exerciser/:identifier",
}